import React, { useEffect, useState } from "react"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"

import { AvForm } from "availity-reactstrap-validation"
import Select from "react-select"
import { getSettings, updateSettings } from "store/settings/actions"

function Settings({ show, onCloseClick, state, setState }) {
  const { Settings } = useSelector(state => ({
    Settings: state.Settings.settings,
  }))
  const [status, setStatus] = useState("both")
  const dispatch = useDispatch()
  const isTablet = window.innerWidth <= 768

  const handleValidSubmit = (e, v) => {
    const Update = {
      booking_option: status?.value,
    }
    if (Settings?._id) {
      dispatch(updateSettings(Update, Settings?._id, onCloseClick))
    }
  }

  useEffect(() => {
    dispatch(getSettings())
  }, [dispatch])

  const bookingOptions = [
    {
      id: 1,
      label: "Pay Later",
      value: "pay_later",
    },
    {
      id: 2,
      label: "Online",
      value: "online_booking",
    },
    {
      id: 3,

      label: "Both",
      value: "both",
    },
  ]

  useEffect(() => {
    if (Settings?.booking_option) {
      const matched = bookingOptions.find(
        s => s.value === Settings.booking_option
      )
      setStatus(matched || null)
    }
  }, [Settings])

  return (
    <div>
      <Modal
        isOpen={show}
        toggle={onCloseClick}
        centered={true}
        className="bg-orange"
        style={{ maxWidth: !isTablet && "310px" }}
      >
        <ModalBody className="p-4">
          <CardTitle>Edit Payment Option</CardTitle>
          <AvForm
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <Row>
              <>
                <Col xs={12} md={12}>
                  <Select
                    value={status}
                    onChange={setStatus}
                    options={bookingOptions}
                    classNamePrefix="select2-selection"
                    placeholder="Select Payment Option"
                  />
                </Col>
              </>
            </Row>

            <div className="d-flex justify-content-end align-items-center">
              <div className="text-center mt-3">
                <button
                  type="button"
                  className="btn btn-light ms-2"
                  onClick={onCloseClick}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-warning ms-2">
                  {Settings?._id ? "Save" : "Create"}
                </button>
              </div>
            </div>
          </AvForm>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default Settings

Settings.propTypes = {
  onCloseClick: PropTypes.any,
  show: PropTypes.any,
  state: PropTypes.any,
  setState: PropTypes.any,
}
